module.exports = __webpack_public_path__ + "img/8.19fc76ce.jpg";